import { Button } from '../Button';
import { ButtonGroup } from '../ButtonGroup';

/**
 * A preset button group that allows the User to select which view they want to see.
 *
 * @component
 * @param {Object} props - component props.
 * @param {Array<{title: string, view: string}>} props.buttons - array of button objects with title and view properties.
 * @param {string} props.currentView - currently selected view.
 * @param {function} props.setView - function to set current view.
 * @param {string} props.themeColor - theme color for the buttons (optional).
 * @returns {JSX.Element} set of buttons that allow user to change views.
 * @description ViewChanger component is a reusable component that allows user to select between different views.
 */
export const ViewChanger = ({ 
  buttons, 
  currentView, 
  setView, 
  themeColor='primary'
}) => {

  const handleViewChange = (newView) => {
    setView(newView);
  };

  return (
    <ButtonGroup>
      {buttons.map((button) => {
        const isSelected = currentView === button.view;
        return (
          <Button
            key={button.view}
            title={button.title}
            content={button.content}
            selected={isSelected}
            togglable={true}
            themeColor={isSelected ? themeColor : 'base'}
            onClick={() => handleViewChange(button.view)}
          />
        );
      })}
    </ButtonGroup>
  );
}